import React from "react";
import TableFixedPage from '../../TableFixedPage/TableFixedPage'
import ProductRestaurantCommentTable from '../../Tables/Comments/ProductRestaurantCommentTable/ProductRestaurantCommentTable'
const ProductRestaurantCommentContainer = () => {
  return (
    <div>
      <TableFixedPage title={"نظرات رستوران"} />
      <ProductRestaurantCommentTable />
    </div>
  );
};

export default ProductRestaurantCommentContainer;
